var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvalid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.405,
    height: 166.827,
    viewBox: "0 0 104.405 166.827",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_973",
    "data-name": "Grupo 973",
    transform: "translate(-10367.043 -3537.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_972",
    "data-name": "Grupo 972",
    transform: "translate(10381.12 3542.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pol\\xEDgono_14",
    "data-name": "Pol\\xEDgono 14",
    d: "M18.975,44.923c1.9-9.685,15.758-9.685,17.662,0L53.5,130.713a9,9,0,0,1-8.831,10.736H10.941A9,9,0,0,1,2.11,130.713Z",
    transform: "matrix(-0.966, -0.259, 0.259, -0.966, 53.718, 151.023)",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_136",
    "data-name": "Elipse 136",
    cx: 20.552,
    cy: 19.948,
    rx: 20.552,
    ry: 19.948,
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 13.89, 112.816)",
    fill: "#FF6600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pol\\xEDgono_13",
    "data-name": "Pol\\xEDgono 13",
    transform: "matrix(-0.966, -0.259, 0.259, -0.966, 10420.761, 3688.833)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.975,44.923c1.9-9.685,15.758-9.685,17.662,0L53.5,130.713a9,9,0,0,1-8.831,10.736H10.941A9,9,0,0,1,2.11,130.713Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 27.80629920959473 44.65882873535156 C 26.16119575500488 44.65882873535156 25.92234039306641 45.87380981445313 25.84386253356934 46.27305603027344 L 8.979026794433594 132.0636138916016 C 8.820507049560547 132.8700408935547 9.172779083251953 133.4474792480469 9.396881103515625 133.7199401855469 C 9.620964050292969 133.9923400878906 10.11963272094727 134.4493865966797 10.94148635864258 134.4493865966797 L 44.6711540222168 134.4493865966797 C 45.49271392822266 134.4493865966797 45.99140167236328 133.9922485351563 46.21554946899414 133.7197570800781 C 46.43967437744141 133.447265625 46.79203033447266 132.8697814941406 46.63354873657227 132.0636138916016 L 29.76873588562012 46.27305603027344 C 29.69025802612305 45.87380981445313 29.45140266418457 44.65882873535156 27.80629920959473 44.65882873535156 M 27.80629920959473 37.65882873535156 C 31.74580001831055 37.65882873535156 35.68529891967773 40.08015441894531 36.63727569580078 44.92282104492188 L 53.50209045410156 130.7133941650391 C 54.59521102905273 136.2739715576172 50.33798217773438 141.4493865966797 44.67114639282227 141.4493865966797 C 44.67079925537109 141.4493865966797 44.67145538330078 141.4493865966797 44.67111206054688 141.4493865966797 L 10.94148635864258 141.4493865966797 C 5.274131774902344 141.4494018554688 1.017318725585938 136.2743072509766 2.110485076904297 130.7133941650391 L 18.97531890869141 44.92282104492188 C 19.92729949951172 40.08015441894531 23.86679840087891 37.65882873535156 27.80629920959473 37.65882873535156 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_135",
    "data-name": "Elipse 135",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 10380.934, 3650.626)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.552,
    cy: 19.948,
    rx: 20.552,
    ry: 19.948,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.552,
    cy: 19.948,
    rx: 17.052,
    ry: 16.448,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalid);
export default __webpack_public_path__ + "static/media/invalid.007359a01a28c10856fdb808d77f5fab.svg";
export { ForwardRef as ReactComponent };